<template>
  <div>
    <Card>
        <p slot="title"> Giro Jatuh Tempo </p>
        <Row type="flex" justify="space-between">
            <Col span="6">
                <ButtonGroup class="custom-group-parent">
                    <Button class="custom-group">Tgl. Terima Giro</Button>
                    <DatePicker
                        v-model="giroDateSelected"
                        type="daterange"
                        placeholder="Select date"
                        style="width: 180px"
                        @on-change="getReceivableGiroList()"/>
                </ButtonGroup>
            </Col>
            <Col span="6">
                <ButtonGroup class="custom-group-parent">
                    <Button class="custom-group">Tgl. Jatuh Tempo</Button>
                    <DatePicker
                        v-model="paymentDateSelected"
                        type="daterange"
                        placeholder="Select date"
                        style="width: 180px"
                        @on-change="getReceivableGiroList()"/>
                </ButtonGroup>
            </Col>
            <Col span="5" style="display: flex;">
                <ButtonGroup class="custom-group-parent">
                    <Button class="custom-group">Marking</Button>
                    <Select
                        filterable
                        clearable
                        placeholder="Select Marking"
                        v-model="markingIdSelected"
                        :remote-method="getMarkingByCode"
                        :loading="isLoadingGetMarking"
                        @on-change="getReceivableGiroList()" >
                        <Option v-for="option in optionMarkings"
                            :value="option.value" :key="option.value">{{option.label}}</Option>
                    </Select>
                </ButtonGroup>
            </Col>
            <Col span="6">
                <Spin size="large" v-show="isLoadingGiroList"></Spin>
            </Col>
        </Row>
        <br/>
        <Card>
          <button type="button" @click="generateReport" class="ivu-btn ivu-btn-default ivu-btn-small" style="margin-right: 5px;"> <span>Generate PDF</span></button>
          <button type="button" @click="generateExcel" class="ivu-btn ivu-btn-default ivu-btn-small" style="margin-right: 5px;"> <span>Generate XLSX</span></button>
          <br/>
          <br/>
            <Alert type="info" show-icon v-show="totalGiro != 0"> Total Giro = {{ totalGiro }} lembar</Alert>
            <Alert type="success" show-icon v-show="totalGiro != 0"> Total Nominal = Rp {{ totalNominal | numberFormatted }}</Alert>
            <!-- <Table border :columns="columnsDataTable" :data="receivableGiroData"></Table> -->
            <!-- Handsontable -->
            <cHotGiroDueDate
                @setHotGiroData="setHotGiroData"
                :key="componentKey"
                :hotHeaders="headerGiroDueDate"
                :hotColumns="columnGiroDueDate"
                :receivableGiroData="receivableGiroData">
            </cHotGiroDueDate>
      </Card>
    </Card>

          <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename= this.filename
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      ref="html2Pdf"
      >
      <section slot="pdf-content">
<div class="container">
	<div class="table">
		<div class="table-header">
			<div class="header__item">Marking</div>
			<div class="header__item">Marking Group</div>
			<div class="header__item">Tgl. Terima Giro</div>
			<div class="header__item">Tgl. Jatuh Tempo</div>
			<div class="header__item">Nomor Giro</div>
			<div class="header__item">Nominal Giro</div>
			<div class="header__item bank-header">Bank</div>
			<div class="header__item">Tgl. Jatuh Tempo</div>
			<div class="header__item">Kliring</div>
			<div class="header__item">Dibatalkan</div>
		</div>
		<div class="table-content">
			<div class="table-row" v-for="value in hotGiroData">
				<div class="table-data">{{ value.marking }}</div>
				<div class="table-data">{{ value.markingGroup }}</div>
				<div class="table-data">{{ value.giroDate }}</div>
				<div class="table-data">{{ value.paymentDate }}</div>
				<div class="table-data">{{ value.giroNumber }}</div>
				<div class="table-data">{{ value.giroNominal }}</div>
				<div class="table-data bank-body">{{ value.accountName }}</div>
				<div class="table-data">{{ value.dueDate }}</div>
				<div class="table-data">{{ value.isClearing }}</div>
				<div class="table-data">{{ value.isCancel }}</div>
			</div>
		</div>
	</div>
</div>
          </section>
        </vue-html2pdf>

      </div>
</template>

<style>
:root {
  --base-spacing-unit: 24px;
  --half-spacing-unit: calc(var(--base-spacing-unit) / 2);

  --color-alpha: #1772FF;
  --color-form-highlight: #495060;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

.container {
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  background-color: white;
  padding: var(--base-spacing-unit);
}

.table {
  width: 100%;
}

.table-header {
  display: flex;
  width: 100%;

  .bank-header{
    flex: 1 1 60%;
  }
}

.table-row {
  display: flex;
  width: 100%;

  .bank-body {
    flex: 1 1 60%;
  }
}

.table-data,
.header__item {
  flex: 1 1 20%;
  text-align: center;
  border: 0.5px solid var(--color-form-highlight);
}

.header__item {
  text-transform: uppercase;
  line-height: 200%;
  font-weight: 500;
}

</style>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import cHotGiroDueDate from '@/components/giro/cHotGiroDueDate';
import VueHtml2pdf from 'vue-html2pdf'
import * as XLSX from 'xlsx'

const numeral = require('numeral');

export default {
    components : {
        cHotGiroDueDate,
        VueHtml2pdf
    },
    data () {
        return {
            isLoadingGiroList: false,
            componentKey: 0,

            giroDateSelected : [],
            paymentDateSelected : [],
            optionMarkings : [],
            markingIdSelected: null,
            isLoadingGetMarking: false,
            isLoadingGiroList: false,
            filename: "giro-jatuh-tempo-" + Date.now() ,
            headerGiroDueDate: ['Marking', 'Marking Group', 'Tgl. Terima Giro', 'Tgl. Jatuh Tempo', 'Nomor Giro', 'Nominal Giro', 'Bank', 'Tgl. Jatuh Tempo', 'Kliring', 'Dibatalkan'],
            columnGiroDueDate: [
                {
                    data: 'marking',
                    type: 'text',
                    readOnly: true
                },
                {
                    data: 'markingGroup',
                    type: 'text',
                    readOnly: true
                },
                {
                    data: 'giroDate',
                    type: 'text',
                    readOnly: true
                },
                {
                    data: 'paymentDate',
                    type: 'text',
                    readOnly: true
                },
                {
                    data: 'giroNumber',
                    type: 'text',
                    readOnly: true
                },
                {
                    data: 'giroNominal',
                    type: 'text',
                    readOnly: true
                },
                {
                    data: 'accountName',
                    type: 'text',
                    readOnly: true
                },
                {
                    data: 'dueDate',
                    type: 'text',
                    readOnly: true
                },
                {
                    data: 'isClearing',
                    type: 'text',
                    readOnly: true
                },
                {
                    data: 'isCancel',
                    type: 'text',
                    readOnly: true
                },
            ],
            receivableGiroData: [],
            hotGiroData: [],

            totalGiro: 0,
            totalNominal: 0,

        }
    },
    methods: {
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        getMarkingByCode: _.debounce(
            function (query) {
                if (query !== '') {
                    this.isLoadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query
                    })
                    .then(response => {
                        this.isLoadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.isLoadingGetMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
        getReceivableGiroList: function(){
            let parent = this;
            let startGiroDate = null;
            let endGiroDate = null;
            let startPaymentDate = null;
            let endPaymentDate = null;

            // handle giro date - tanggal terima giro
            if(this.giroDateSelected[0] != "" && this.giroDateSelected[0] != null) {
                startGiroDate = moment(this.giroDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endGiroDate = moment(this.giroDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            // handle payment date / tanggal jatuh tempo
            if(this.paymentDateSelected[0] != "" && this.paymentDateSelected[0] != null) {
                startPaymentDate = moment(this.paymentDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endPaymentDate = moment(this.paymentDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            let payload = {
                isDue: true,
                startGiroDate: startGiroDate,
                endGiroDate: endGiroDate,
                startPaymentDate: startPaymentDate,
                endPaymentDate: endPaymentDate,
                markingHeaderId: this.markingIdSelected
            }

            console.log({payload});

            this.isLoadingGiroList = true;
            HTTP.post('giro/search', payload)
            .then(response => {
                let receivableGiro = []

                // reset calculate total giro & total nominal
                parent.totalGiro = 0
                parent.totalNominal = 0

                _.forEach(response.data, function(value, index) {
                    let giroId = value.id
                    let giroDate = parent.showDateFormatted(value.giroDate)
                    // let giroDate = moment(value.giroDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD")
                    let giroNumber = value.giroNumber
                    let giroNominal = "Rp. " + numeral(value.giroNominal).format('0,0')
                    // let paymentDate = parent.showDateFormatted(value.paymentDate)
                    let paymentDate = parent.showDateFormatted(value.paymentDate)
                    let accountName = value.bank_account != null ? value.bank_account.accountName : ''
                    // let dueDate = parent.showDateFormatted(value.dueDate)
                    let dueDate = (value.dueDate != null && value.dueDate != "0000-00-00 00:00:00") ? parent.showDateFormatted(value.dueDate) : '-'
                    // let dueDate = moment(value.dueDate, 'YYYY-MM-DD hh:mm:ss').format("YYYY-MM-DD")
                    let isClearing = value.isClearing == 1 ? 'Ya' : 'Tidak'
                    let isCancel = value.isCancel == 1 ? 'Ya' : 'Tidak'
                    let marking = value.marking_header != null ? value.marking_header.markingheadercode : ''
                    let markingGroup = value.marking_group != null ? value.marking_group.code : ''

                    let rGiro = {
                        marking : marking,
                        markingGroup : markingGroup,
                        giroId : giroId,
                        giroDate : giroDate,
                        giroNumber : giroNumber,
                        giroNominal: giroNominal,
                        paymentDate: paymentDate,
                        accountName: accountName,
                        dueDate: dueDate,
                        isClearing: isClearing,
                        isCancel: isCancel
                    }
                    receivableGiro.push(rGiro);

                    // calculate total giro & total nominal
                    parent.totalGiro++
                    parent.totalNominal += value.giroNominal
                });

                this.receivableGiroData = receivableGiro;
                this.componentKey += 1; // re-render compononent handsontable
                this.isLoadingGiroList = false;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });
        },
        setHotGiroData(hotGiroData) {
          const arrayGiroData = []
         // paymentDate giroNumber giroNominal accountName dueDate
          hotGiroData.forEach(value => {
            let girodata = {
              marking: value[0],
              markingGroup: value[1],
              giroDate: value[2],
              paymentDate: value[3],
              giroNumber: value[4],
              giroNominal: value[5],
              accountName: value[6],
              dueDate: value[7],
              isClearing: value[8],
              isCancel: value[9],
            }
            arrayGiroData.push(girodata)
          })
          this.hotGiroData = arrayGiroData
        },
        generateReport () {
          this.$refs.html2Pdf.generatePdf()
         },
         generateExcel : function() {
          const data = XLSX.utils.json_to_sheet(this.hotGiroData)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, data, 'Jatuh tempo')
          XLSX.writeFile(wb, this.filename + '.xlsx')
      }
    },
    mounted() {
        this.getReceivableGiroList()
        this.$Loading.config({
            color: '#fff',
            failedColor: '#f0ad4e',
            height: 10
        });
    }
}

</script>



// WEBPACK FOOTER //
// GiroDueDate.vue?322925cc